import { Box, useTheme } from "@mui/material"
import PageHeader from "../../components/PageHeader"
import constants from "../../constants"

const PrivacyPolicy = () => {
  const theme = useTheme()

  return (
    <>
      <PageHeader iconName="file-lines" headerName="Privacy Policy" />
      <Box sx={{color: theme.palette.color50555b.main}}  className="m-16">
        <iframe
          style={{ width: '100%', height: '100vh', border: 'none'}}
          className="iframe-privacy-policy-page"
          data-testid="privacy-policy-iframe"
          src={constants.PRIVACY_POLICY_PAGE_URL}
        />
      </Box>
    </>
  )
}

export default PrivacyPolicy
